module.exports = __webpack_public_path__ + "static/media/icon_nav_product_active.4cfdc516.svg";